import React, {useEffect, useState} from "react";
import AppRoutes from "../AppRoutes";
import NavBar from "./Navigation/NavBar";
import Sidebar from "./Navigation/Sidebar";
import {SystemError} from "./Error/SystemError";
import TokenExchange from "./Login2/TokenExchange";
import useAppContext from "../util/AppContext";
import {SessionContext} from "../util/SessionContext";
import EventBus from "../util/EventBus";

export default function Layout() {
    const sessionContext: SessionContext = useAppContext()?.sessionContext!;
    const [loggedIn, setLoggedIn] = useState<boolean>(!!sessionContext?.valid());

    useEffect(() => {
        const onSessionUpdate = () => setLoggedIn(!!sessionContext?.valid());
        EventBus.session.addListener("update", onSessionUpdate);
        onSessionUpdate();
        return () => {
            EventBus.session.removeListener("update", onSessionUpdate);
        };
    }, [sessionContext]);

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100vh"}}>
            <TokenExchange />
            <NavBar />
            <div style={{display: "flex", flexDirection: "row", flex: 1, minHeight: 0}}>
                {loggedIn && <Sidebar />}
                <div style={{flex: 1, overflow: "auto"}}>
                    <AppRoutes />
                </div>
            </div>
            <SystemError />
        </div>
    );
}
